export default __webpack_public_path__ + "static/Kazmierczak-e17e8f45bf4652c59aff6dc806ac70ff.jpg";